import React from "react";
import ContentLoader from "react-content-loader";

const SkeletonColorMap = (props) => (
  <ContentLoader
    speed={2}
    width={1290}
    height={169}
    viewBox="0 0 1290 169"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    {/*<rect x="0" y="0" rx="0" ry="0" width="306" height="169" />*/}

    <rect x="386" y="0" rx="0" ry="0" width="80" height="49" />
    <rect x="477" y="0" rx="0" ry="0" width="80" height="49" />
    <rect x="568" y="0" rx="0" ry="0" width="80" height="49" />
    <rect x="659" y="0" rx="0" ry="0" width="80" height="49" />
    <rect x="750" y="0" rx="0" ry="0" width="80" height="49" />
    <rect x="841" y="0" rx="0" ry="0" width="80" height="49" />
    <rect x="932" y="0" rx="0" ry="0" width="80" height="49" />
    <rect x="1023" y="0" rx="0" ry="0" width="80" height="49" />
    <rect x="1114" y="0" rx="0" ry="0" width="80" height="49" />
    <rect x="1205" y="0" rx="0" ry="0" width="80" height="49" />

    <rect x="386" y="60" rx="0" ry="0" width="80" height="49" />
    <rect x="477" y="60" rx="0" ry="0" width="80" height="49" />
    <rect x="568" y="60" rx="0" ry="0" width="80" height="49" />
    <rect x="659" y="60" rx="0" ry="0" width="80" height="49" />
    <rect x="750" y="60" rx="0" ry="0" width="80" height="49" />
    <rect x="841" y="60" rx="0" ry="0" width="80" height="49" />
    <rect x="932" y="60" rx="0" ry="0" width="80" height="49" />
    <rect x="1023" y="60" rx="0" ry="0" width="80" height="49" />
    <rect x="1114" y="60" rx="0" ry="0" width="80" height="49" />
    <rect x="1205" y="60" rx="0" ry="0" width="80" height="49" />

    <rect x="386" y="120" rx="0" ry="0" width="80" height="49" />
    <rect x="477" y="120" rx="0" ry="0" width="80" height="49" />
    <rect x="568" y="120" rx="0" ry="0" width="80" height="49" />
    <rect x="659" y="120" rx="0" ry="0" width="80" height="49" />
    <rect x="750" y="120" rx="0" ry="0" width="80" height="49" />
    <rect x="841" y="120" rx="0" ry="0" width="80" height="49" />
    <rect x="932" y="120" rx="0" ry="0" width="80" height="49" />
    <rect x="1023" y="120" rx="0" ry="0" width="80" height="49" />
    <rect x="1114" y="120" rx="0" ry="0" width="80" height="49" />
    <rect x="1205" y="120" rx="0" ry="0" width="80" height="49" />

    <rect x="1287" y="0" rx="1" ry="1" width="3" height="93" />
  </ContentLoader>
);

export default SkeletonColorMap;
